import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=5b5fe31c&"
import script from "./Search.ts?vue&type=script&lang=ts&"
export * from "./Search.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports